import CodeMirrorHelper from "./CodeMirrorHelper";


const humanFileSize = (bytes, si) => {
  let thresh = si ? 1000 : 1024;
  if(Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }
  let units = si
    ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
    : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
  let u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while(Math.abs(bytes) >= thresh && u < units.length - 1);
  return bytes.toFixed(1)+' '+units[u];
};


class CodeMirrorTistory {
  static insertImage(cm, data) {
    CodeMirrorHelper.insertText(cm,
      `[##_Image|kage@${data.key}/${data.filename}|alignCenter|width="100%"|_##]`
    );
  }

  static insertFile(cm, data) {
    CodeMirrorHelper.insertText(cm,
      `[##_File|kage@${data.key}/${data.filename}|filename="${data.name}" size="${humanFileSize(data.size, true)}"|_##]`
    );
  }
}

export default CodeMirrorTistory;
